import { BrowserModule } from '@angular/platform-browser';
import { NgModule, APP_INITIALIZER } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { RouterModule } from '@angular/router';

import { NgbModule, NgbModal, NgbDropdown, NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';

import { AppComponent } from './app.component';  
import { NavMenuComponent } from '@layout/nav-menu/nav-menu.component';
import { HomeComponent } from '@pages/home/home.component';
import { LoginComponent } from '@auth/login/login.component';
import { ChangePasswordComponent } from '@auth/change-password/change-password.component';
import { AddToClassComponent } from '@admin/add-to-class/add-to-class.component';
import { appRoutes } from './route';
import { JwtModule } from '@auth0/angular-jwt';
import { RegisterComponent } from '@auth/register/register.component';

import { FontAwesomeModule } from '@fortawesome/angular-fontawesome'
import { NgCircleProgressModule } from 'ng-circle-progress';

import { library } from '@fortawesome/fontawesome-svg-core';
import { faFilm } from '@fortawesome/free-solid-svg-icons';
import { fas, faEllipsisV } from '@fortawesome/free-solid-svg-icons';
import { ClassesComponent } from '@classes/classes-list/classes.component';
import { WelcomeComponent } from '@userOnboarding/welcome/welcome.component';
import { ConstructionComponent } from '@pages/construction-page/construction.component';
import { FooterComponent } from '@layout/footer/footer.component';
import { PublicLayoutComponent } from './layout/public-layout/public-layout.component';
import { PrivateLayoutComponent } from './layout/private-layout/private-layout.component';
import { VideoComponent } from '@classes/class-video/video.component';
import { MessageNewUserComponent } from '@userOnboarding/message-new-user/message-new-user.component';
import { MessageSignupComponent } from '@userOnboarding/message-signup/message-signup.component';
import { ErrorInterceptorProvider } from '@services/error.interceptor.service';
// import { QuizzComponent } from './quizz/quizz.component';
import { QuizComponent } from '@classes/class-quiz/quiz.component';
import { ConfirmEmailComponent } from '@app/features/auth/confirm-email/confirm-email.component';
import { LearnMoreComponent } from '@pages/learn-more/learn-more.component';
import { ResetPasswordComponent } from '@app/features/auth/reset-password/reset-password.component';
import { ContactUsComponent } from '@pages/contact-us/contact-us.component';
import { LoginHelpComponent } from '@app/features/auth/login-help/login-help.component';
import { ContactUsSentComponent } from '@pages/contact-us-sent/contact-us-sent.component';
import { DashboardComponent } from '@pages/dashboard/dashboard.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {MatInputModule} from '@angular/material/input';
import {  RxReactiveFormsModule } from "@rxweb/reactive-form-validators"
import { LoginAuthGuard } from "@core/guards/LoginAuthGuard"
import { AdminAuthGuard } from "@core/guards/AdminAuthGuard"
import { CheckCompletion } from '@services/check-completion.service';
import { CourseService } from '@services/course.service';
import { ConfigurationService } from '@services/configuration.service';

// Configuration initialization factory
export function initializeConfiguration(configService: ConfigurationService) {
  return () => configService.loadCourseSettings();
}
import { AdminNavComponent } from '@admin/dashboard/components/admin-panel-nav/admin-panel-nav.component';
import { AdminComponent } from '@admin/dashboard/pages/admin-panel/admin-panel.component';
import { AdminClassesComponent } from '@admin/dashboard/pages/admin-panel-classes/admin-panel-classes.component';
import { AdminUsersComponent } from '@admin/dashboard/pages/admin-panel-users/admin-panel-users.component';
import { AdminUserComponent } from '@admin/dashboard/pages/admin-panel-user/admin-panel-user.component';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { ClassCardComponent } from '@classes/class-card/class-card.component';
// import { ModalModule, BsModalService } from 'ngx-bootstrap/modal';
import {MatDialogModule} from '@angular/material/dialog';
import { ClassPopupComponent } from '@classes/class-popup/class-popup.component';
import { PopupComponent } from '@components/popup/popup.component';
import { CourseCompletionModalComponent } from '@shared/components/course-completion-modal/course-completion-modal.component';
import { PaginationModule } from 'ngx-bootstrap/pagination';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';

import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { LanguageSwitcherComponent } from '@components/language-switcher/language-switcher.component';
import { environment } from 'src/environments/environment.prod';

import { BootstrapModalComponent } from '@shared/components/bootstrap-modal/bootstrap-modal.component';

//import { AlertModule, SidebarModule } from 'ng-cdbangular';
// import { getStuff } from '../services/user-classes.service';
// import { distinctPasswordsError } from './shared/CustomValidators'
// import { CompareDirective } from './shared/compare.directive'
//import { ifViewportSize } from './services/screensize.service';

/* Send Token  */
export function tokenGetter() {
  return localStorage.getItem('token');
}

// Factory function for loading translation files
export function HttpLoaderFactory(http: HttpClient) {
  //return new TranslateHttpLoader(http, './assets/i18n/', '.json');
    const config = environment.translationConfig;
  return new TranslateHttpLoader(
    http, 
    config.translationPath, 
    config.translationSuffix
  );
}

@NgModule({
  declarations: [
    AppComponent,
    NavMenuComponent,
    HomeComponent,
    ConstructionComponent,
    LoginComponent,
    ChangePasswordComponent,
    RegisterComponent,
    AddToClassComponent,
    ClassesComponent,
    WelcomeComponent,
    FooterComponent,
    PublicLayoutComponent,
    PrivateLayoutComponent,
    VideoComponent,
    MessageNewUserComponent,
    MessageSignupComponent,
    QuizComponent,
    ConfirmEmailComponent,
    LearnMoreComponent,
    ResetPasswordComponent,
    ContactUsComponent,
    LoginHelpComponent,
    ContactUsSentComponent,
    DashboardComponent,
    AdminNavComponent,
    AdminComponent,
    AdminClassesComponent,
    AdminUsersComponent,
    ClassCardComponent,
    ClassPopupComponent,
    PopupComponent,
    LanguageSwitcherComponent,
    CourseCompletionModalComponent,
    BootstrapModalComponent
  ],
  imports: [
    BrowserModule.withServerTransition({ appId: 'ng-cli-universal' }),
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      },
        defaultLanguage: environment.defaultLanguage,
        useDefaultLang: true
    }),
    FormsModule,
    ReactiveFormsModule,  // we use reactive forms instead of driven forms , avoid error: Can't bind to 'formGroup' since it isn't a known property of 'form'
    AdminUserComponent,  // Standalone component import
    RouterModule.forRoot(appRoutes, { scrollPositionRestoration: 'enabled' }), // routes
    NgbModule,
    NgbDropdownModule,
    JwtModule.forRoot({
      config: {
        tokenGetter: tokenGetter,
        allowedDomains: [
          'localhost:57340', 
          'intercessory.livingwd.org', 
          'testintercessorylivingwd.azurewebsites.net', 
          'localhost:5000',
          'localhost:5001', // Add this for your HTTPS development server
          'intercessory-sp.livingwd.org' // Add your new domain here
        ],
        disallowedRoutes: ['localhost:5001/api/auth', 'localhost:5000/api/auth']
      }
    })
    , FontAwesomeModule
    , NgCircleProgressModule.forRoot({
      // set defaults here
      radius: 100,
      outerStrokeWidth: 16,
      innerStrokeWidth: 8,
      outerStrokeColor: "#78C000",
      innerStrokeColor: "#C7E596",
      animationDuration: 300,
    }), BrowserAnimationsModule,
    MatInputModule,
    MatDialogModule,
    RxReactiveFormsModule,
    BsDropdownModule,
    PaginationModule.forRoot(),
    MatSlideToggleModule,
    
    // ModalModule,
   // , AngularFontAwesomeModule
  ],
  providers: [
    ErrorInterceptorProvider, 
    LoginAuthGuard, 
    AdminAuthGuard,
    CheckCompletion,
    ConfigurationService,
    {
      provide: APP_INITIALIZER,
      useFactory: initializeConfiguration,
      deps: [ConfigurationService],
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor() {
    library.add(fas, faEllipsisV, faFilm );
  }
}
